var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteRoundSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 246,
    height: 248,
    viewBox: "0 0 246 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dde3a",
    d: "M1492.1 3779.59c14.72 34.05-1.01 73.6-35.13 88.33-34.11 14.74-73.69-.92-88.4-34.97-14.7-34.05 1.03-73.6 35.14-88.33 34.11-14.74 73.7.92 88.4 34.97z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "dde3c",
    width: 2,
    height: 2,
    x: -1,
    y: -1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1363 3739h135v135h-135z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dde3a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dde3b",
    width: 328.9,
    height: 368.6,
    x: 1272,
    y: 3648,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.9,
    dy: 51.6,
    in: "SourceGraphic",
    result: "FeOffset1023Out"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "FeOffset1023Out",
    result: "FeGaussianBlur1024Out",
    stdDeviation: "32.4 32.4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1321 -3734)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#dde3b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    strokeOpacity: 0.15,
    strokeWidth: 0,
    mask: "url(\"#dde3c\")",
    xlinkHref: "#dde3a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#080011",
    fillOpacity: 0.15,
    xlinkHref: "#dde3a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#dde3a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRoundSm);
export default __webpack_public_path__ + "static/media/white-round-sm.75c58bb3e8da62d74bfdc69cdf33d230.svg";
export { ForwardRef as ReactComponent };